import { Injectable } from '@angular/core';
import { cibVoteDisplayNames } from '../models/ci/ci-vote';
import { iecBallotVoteDisplayNames } from '../../../../shared/constants/iec-ballot.constants';
import { IDonutChartItem } from '../../../controls/donut-chart/donut-chart.component';

@Injectable({
  providedIn: 'root'
})
export class BallotCalculationService {

  constructor() { }

  calculatePercentages(data: IDonutChartItem[]): IDonutChartItem[] {
    const total = data.reduce((sum, item) => sum + (item.weight ?? item.value), 0);

    let percentages = data.map(item => ({
      ...item,
      percentage: total ? Math.round(((item.weight ?? item.value) / total) * 100) : 0
    }));

    // Adjust rounding errors to ensure the total is exactly 100%
    let diff = 100 - percentages.reduce((sum, item) => sum + item.percentage, 0);
    if (diff !== 0) {
      let indexToAdjust = percentages.findIndex(item => item.percentage > 0);
      if (indexToAdjust !== -1) {
        percentages[indexToAdjust].percentage += diff;
      }
    }

    return percentages;
  }

  isNoResponseFull(data: IDonutChartItem[]): boolean {
    const noResponseItem = data.find(item => item.label === iecBallotVoteDisplayNames.noResponse);
    return noResponseItem ? noResponseItem.percentage === 100 : false;
  }

  hasMajorityInFavorOf(data: IDonutChartItem[]): boolean {
    const inFavourVotes = data.find(item => item.label === iecBallotVoteDisplayNames.inFavourOf)?.value || 0;
    const againstVotes = data.find(item => item.label === iecBallotVoteDisplayNames.against)?.value || 0;
    const abstainVotes = data.find(item => item.label === iecBallotVoteDisplayNames.abstain)?.value || 0;

    return inFavourVotes > 0 && inFavourVotes > againstVotes && inFavourVotes >= abstainVotes;
  }

  hasMajorityAgainst(data: IDonutChartItem[]): boolean {
    const againstVotes = data.find(item => item.label === iecBallotVoteDisplayNames.against)?.value || 0;
    const inFavourVotes = data.find(item => item.label === iecBallotVoteDisplayNames.inFavourOf)?.value || 0;
    const abstainVotes = data.find(item => item.label === iecBallotVoteDisplayNames.abstain)?.value || 0;

    return againstVotes > 0 && againstVotes > inFavourVotes && againstVotes >= abstainVotes;
  }

  hasMajorityAbstain(data: IDonutChartItem[]): boolean {
    const againstVotes = data.find(item => item.label === iecBallotVoteDisplayNames.against)?.value || 0;
    const inFavourVotes = data.find(item => item.label === iecBallotVoteDisplayNames.inFavourOf)?.value || 0;
    const abstainVotes = data.find(item => item.label === iecBallotVoteDisplayNames.abstain)?.value || 0;

    return abstainVotes > 0 && abstainVotes > inFavourVotes && abstainVotes > againstVotes;
  }

  isVoteTiedForFinalisation(data: IDonutChartItem[]): boolean {
    const inFavourVotes = data.find(item => item.label === iecBallotVoteDisplayNames.inFavourOf)?.value || 0;
    const againstVotes = data.find(item => item.label === iecBallotVoteDisplayNames.against)?.value || 0;
    const abstainVotes = data.find(item => item.label === iecBallotVoteDisplayNames.abstain)?.value || 0;

    return inFavourVotes > 0 && inFavourVotes >= abstainVotes && inFavourVotes === againstVotes;
  }


   hasMajorityAgree(data: IDonutChartItem[]): boolean {
    const agreeVotes = data.find(item => item.label === cibVoteDisplayNames.agree)?.value || 0;
    const disagreeVotes = data.find(item => item.label === cibVoteDisplayNames.disagree)?.value || 0;

    return agreeVotes > 0 && agreeVotes > disagreeVotes;
  }

  hasMajorityDisagree(data: IDonutChartItem[]): boolean {
    const agreeVotes = data.find(item => item.label === cibVoteDisplayNames.agree)?.value || 0;
    const disagreeVotes = data.find(item => item.label === cibVoteDisplayNames.disagree)?.value || 0;

    return disagreeVotes > 0 &&  disagreeVotes > agreeVotes;
  }

   isVoteTiedForCIBFinalisation(data: IDonutChartItem[]): boolean {
    const agreeVotes = data.find(item => item.label === cibVoteDisplayNames.agree)?.value || 0;
    const disagreeVotes = data.find(item => item.label === cibVoteDisplayNames.disagree)?.value || 0;

    return agreeVotes > 0 && disagreeVotes > 0 && agreeVotes === disagreeVotes;
  }


}
